<template lang="html">
  <div class="ui-choose-wrapper">
    <div
      class="ui-choose"
      :class="{ chooseHover: show === 0, 'title-hide': !showTitle }"
    >
      <ul class="ui-choose-select ui-choose-scroll">
        <li
          class="ui-choose-select-item"
          :class="{ hover: isAll }"
          @click="selectAll()"
        >
          全部
        </li>
        <li
          class="ui-choose-select-item"
          v-for="(item, index) in businessList"
          :class="{ hover: item.selected }"
          @click="getAll(item, index, $event)"
        >
          {{ item.businessName }}
        </li>
      </ul>
    </div>
    <div class="ui-button" v-if="params.supportMuti">
      <button class="ui-reset-select" @click="reset">重置</button
      ><button class="ui-comfrim-select" @click="submit">确定</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    needRestBt: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  components: {
    star
  },
  data() {
    return {
      api: '',
      show: 0,
      serviceList: [],
      isAll: false
    }
  },
  watch: {
    isActionSheetShow(val) {
      // console.log(val)
      if (val) {
        if (this.serviceList && this.serviceList.length > 0) {
          this.init()
        }
      }
    }
  },
  computed: {
    ...mapState(['isActionSheetShow', 'businessList', 'filterBusiness'])
  },
  methods: {
    ...mapMutations([
      'setFilterBusiness',
      'setBusinessList',
      'hideActionSheet'
    ]),
    toggle(index) {
      this.show = index
    },
    getAll(item, index, $e) {
      if (!this.params.supportMuti) {
        this.reset()
      }
      item.selected = !item.selected
      if (!item.selected) {
        this.isAll = false
      }
      this.$set(this.businessList, index, item)
      const selected = this.businessList.filter(s => s.selected)
      if (selected.length === this.businessList.length) {
        this.isAll = true
      }
      if (!this.params.supportMuti) {
        this.submit()
      }
    },
    selectAll() {
      this.isAll = !this.isAll
      if (this.params.supportMuti) {
        this.businessList.forEach((level, index) => {
          level.selected = this.isAll
          this.$set(this.businessList, index, level)
        })
      } else {
        this.reset()
        this.submit()
      }
    },
    reset() {
      this.businessList.forEach((level, index) => {
        level.selected = false
        this.$set(this.businessList, index, level)
      })
      this.isAll = false
    },
    submit() {
      const selectedList = this.businessList.filter(v => v.selected)
      console.log(selectedList)
      this.setFilterBusiness(selectedList)
      this.hideActionSheet(false)
    },
    async init() {
      this.isAll = false
      if (this.businessList.length === 0) {
        const json = await this.$store.dispatch('getBusinessListByCity', {
          gbCode: this.params.cityId
        })
        this.setBusinessList(json)
      }
      setTimeout(() => {
        if (
          this.$route.name === 'category-detail' ||
          this.$route.name === 'category-product' ||
          this.$route.name === 'products'
        ) {
          setTimeout(() => {
            console.log(
              'rerenderSheet',
              document.querySelector('.ui-choose-scroll').offsetHeight
            )
            document.querySelector('.actionsheet').style.height = '500px'
          }, 0)
        }
      }, 0)
      // this.serviceList = [...this.serviceTypeList]
      // this.serviceList.forEach((o) => {
      //     o.selected = false
      //     const selectedArr = this.filterService.filter(v => v.categoryId * 1 === o.categoryId * 1)
      //     if (selectedArr && selectedArr.length > 0) {
      //         o.selected = true
      //     }
      // })
      // if (this.serviceList.length === this.filterService.length && this.filterService.length > 0) {
      //     this.isAll = true
      // }
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss">
@import '../../../assets/css/mixin';
.ui-choose {
  .ui-choose-select-item {
    p {
      font-size: rem(30px);
      color: #121212;
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../../assets/css/mixin';
.ui-choose-wrapper {
  position: relative;
  height: 100%;
}
.ui-choose {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
  display: none;

  &::-webkit-scrollbar {
    // width: 1px;
    // // height: 16px;
    // background-color: red;
  }
  .ui-choose-select {
    font-size: 0;
    margin-top: rem(10px);
    margin-bottom: rem(100px);
    .ui-choose-select-item {
      margin-left: rem(25px);
      font-size: rem(30px);
      height: rem(80px);
      position: relative;
      width: 3.3rem;
      display: inline-flex;
      align-items: center;

      &.hover {
        color: #ff397e;

        &:before {
          font-family: iconfont !important;
          font-size: 28px;
          line-height: 45px;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          -webkit-text-stroke-width: 0.2px;
          display: block;
          // color: rgba(0,0,0,.5);
          color: #ff397e;
          content: '\e6e1';
          position: absolute;
          right: 15px;
          top: 50%;
          margin-top: -22px;
          margin-right: -10px;
        }
      }
    }

    .selected:after {
      font-family: iconfont !important;
      font-size: 16px;
      line-height: 45px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -webkit-text-stroke-width: 0.2px;
      display: block;
      // color: rgba(0,0,0,.5);
      color: #ff397e;
      content: '\e6e1';
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -22px;
      margin-right: -10px;
    }
  }

  &.chooseHover {
    display: block;
  }
  &.title-hide {
    top: 0;
  }
}

.ui-choose-group {
  display: flex;
  font-size: rem(30px);
  line-height: rem(80px);
  text-align: center;
  .ui-choose-group-item {
    @include border(bottom);
    flex: 1;
    &.hover {
      color: #ff397e;
      &::before {
        border-bottom: 1px solid #ff397e;
      }
    }
  }
}
.ui-button {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: rem(100px);
  text-align: center;
  z-index: 99;
}
.ui-reset-select {
  background-color: #fff;
  color: #121212;
  width: 100%;
  height: rem(100px);
  font-size: rem(32px);
  // display: inline-block;
  line-height: rem(100px);
  border-top: 1px solid #ebebeb;
  // @include border(top);
}
.ui-comfrim-select {
  background-color: #ff6ea2;
  width: 100%;
  color: #fff;
  // display: inline-block;
  height: rem(100px);
  font-size: rem(32px);
}
</style>
